var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLibraryBooks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_425_37",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_425_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H10.5V9H7.5V10.5ZM7.5 8.25H13.5V6.75H7.5V8.25ZM7.5 6H13.5V4.5H7.5V6ZM6 13.5C5.5875 13.5 5.2345 13.3533 4.941 13.0598C4.647 12.7658 4.5 12.4125 4.5 12V3C4.5 2.5875 4.647 2.23425 4.941 1.94025C5.2345 1.64675 5.5875 1.5 6 1.5H15C15.4125 1.5 15.7658 1.64675 16.0598 1.94025C16.3533 2.23425 16.5 2.5875 16.5 3V12C16.5 12.4125 16.3533 12.7658 16.0598 13.0598C15.7658 13.3533 15.4125 13.5 15 13.5H6ZM6 12H15V3H6V12ZM3 16.5C2.5875 16.5 2.2345 16.3533 1.941 16.0598C1.647 15.7658 1.5 15.4125 1.5 15V4.5H3V15H13.5V16.5H3Z",
    fill: "#1C1B1F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLibraryBooks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/library_books.432cf7d7abbfd37730e93c4096bdd590.svg";